import axios from "axios";

// Get token from sessionStorage
const getAuthToken = () => {
  return sessionStorage.getItem("authToken");
};

// Create an Axios instance with default headers
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Backend base URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Add the token to the headers for each request if available
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Fetch all quizzes
//export const getQuizzes = () => axiosInstance.get("/api/quizzes/list?project=jagranquiz");
export const getQuizzes = (project) => {
  const url = project ? `/api/quizzes/list?project=${project}` : "/api/quizzes/list";
  return axiosInstance.get(url);
};

//export const getAllQuestions = () => axiosInstance.get("/api/questions/");

export const getAllQuestions = (project) => {
  const url = project ? `/api/questions/?project=${project}` : "/api/questions/";
  return axiosInstance.get(url);
};
// Fetch questions by quiz ID
export const getQuestionsByQuizId = (id) => axiosInstance.get(`/api/questions/quiz/${id}`);

// Create a quiz with an Excel file upload
export const createQuizWithFile = (formData, onUploadProgress) => {
  return axiosInstance.post("/api/questions/bulk-upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

// Delete a quiz
export const deleteQuiz = (id) => axiosInstance.get(`/api/quizzes/delete/${id}`);

// Update an existing quiz
export const updateQuiz = (quizData) => axiosInstance.post(`/api/quizzes/update`, quizData);//update put to patch

// Update a single question by unique_id
export const updateQuestion = (updatedData) => {
  return axiosInstance.post(`/api/questions/update`, updatedData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// Delete a question
export const deleteQuestion = async (question_id) => {
  return await axiosInstance.delete(`/api/questions/delete/${question_id}`);
};

// Toggle question status
export const toggleQuestionStatus = async (questionId, isActive) => {
  try {
    const response = await axiosInstance.post(`/api/questions/toggle-status`, { is_active: isActive,question_id:questionId });
    return response.data;
  } catch (error) {
    console.error("Error updating question status:", error);
    throw error;
  }
};

// Fetch categories
export const fetchCategories = async (project) => {
  try {
    //const response = await axiosInstance.get('/api/categories/list');

    const url = project ? `/api/categories/list?project=${project}` : "/api/categories/list";
  const response = await axiosInstance.get(url);

    if (response.status === 200 && response.data.success) {
      return response.data.data; // Return the array of categories
    } else {
      throw new Error(response.data.message || "Failed to fetch categories");
    }
  } catch (error) {
    console.error("Error fetching categories:", error.response || error.message);
    throw error; // Re-throw the error for the calling function to handle
  }
};




export const getAllPrizes = async () => {
  try {
    //const response = await axiosInstance.get('/api/categories/list');

    const url =  "/api/prizes/prizeslist";
  const response = await axiosInstance.get(url);

    if (response.status === 200 && response.data.success) {
      return response.data.data; // Return the array of categories
    } else {
      throw new Error(response.data.message || "Failed to fetch categories");
    }
  } catch (error) {
    console.error("Error fetching categories:", error.response || error.message);
    throw error; // Re-throw the error for the calling function to handle
  }
};


export const uploadPrizeFile = (formData, onUploadProgress) => {
  return axiosInstance.post("/api/prizes/bulk-upload-prize", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};


export const deleteAllPrizes = async () => {
  try {
    const response = await axiosInstance.get(`/api/prizes/prizesdeleted`);
    return response.data;
  } catch (error) {
    console.error("Error deleting prizes:", error.response?.data || error.message);
    throw new Error("Failed to delete prizes");
  }
};




// Add a new category
export const addCategory = async (categoryData) => {
  try {
    const response = await axiosInstance.post('/api/categories/add', categoryData);
    return response.data;
  } catch (error) {
    throw new Error("Failed to add category");
  }
};

// Update an existing category
export const updateCategory = async (oldCatId, newCatName, description, language, active) => {
  try {
    const response = await axiosInstance.post('/api/categories/update', {
      oldCatId,
      newCatName,
      description,
      language,
      active,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating category:", error.response.data);
    throw new Error(error.response.data.message || "Failed to update category");
  }
};

// Toggle category status (active/inactive)
export const toggleCategoryStatus = async (catId, isActive) => {
  try {
    const response = await axiosInstance.post('/api/categories/toggle-status', {
      catId,
      isActive,
    });
    return response.data;
  } catch (error) {
    console.error("Error toggling category status:", error.response || error.message);
    throw error;
  }
};

// Fetch statistics
export const getStatistics = async () => {
  return axiosInstance.get('/api/statistics'); // Replace with your actual endpoint
};

// Fetch quiz by ID
export const getQuizById = (id) => axiosInstance.get(`/api/quizzes/${id}`);

// Create a new quiz
export const createQuiz = (quizData) => axiosInstance.post('/api/quizzes', quizData);

// Login user and store the token (using axios)
export const loginUser = async (email, password) => {
  try {
    const response = await axiosInstance.post("/api/users/login", { email, password });
    console.log(response);

    if (response.status === 200 && response.data?.data?.token) {
      const { token, role , project } = response.data.data;

      sessionStorage.setItem("authToken", token);
      sessionStorage.setItem("loginTime", new Date().toISOString());
      sessionStorage.setItem("userRole", role);
      sessionStorage.setItem("project", project);

      return { success: true, token, role  , project}; // ✅ Return the token properly
    } else {
      return { success: false, message: response.data?.message || "Unknown error" };
    }
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Login failed" };
  }
};

// ✅ Add a new admin (only for super_admin)
export const addAdmin = async (adminData) => {
  try {
    const response = await axiosInstance.post("/api/users/register", adminData);
    return response.data;
  } catch (error) {
    console.error("Error adding admin:", error.response?.data || error.message);
    throw new Error("Failed to add admin");
  }
};

// ✅ Fetch all admins
export const getAdmins = async () => {
  try {
    const response = await axiosInstance.get("/api/users/admins");
    return response.data;
  } catch (error) {
    console.error("Error fetching admins:", error.response?.data || error.message);
    throw new Error("Failed to fetch admins");
  }
};

export const toggleUserActive = async (userId) => {
  try {
    console.log(userId)
    const response = await axiosInstance.post("/api/users/toggle-active", { userId });
    return response.data; // Response contains { "userId": "67b70e028fc50334e23df4a2" }
  } catch (error) {
    console.error("Error toggling user status:", error);
    throw error;
  }
};


// ✅ Delete an admin (only for super_admin)
export const deleteAdmin = async (adminId) => {
  try {
    const response = await axiosInstance.delete(`/api/users/admins/${adminId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting admin:", error.response?.data || error.message);
    throw new Error("Failed to delete admin");
  }
};
export const fetchAdmins = async () => {
  try {
    const response = await axiosInstance.get("/api/users/admin-list");
    return response.data.data; // Assuming API returns { success: true, data: [...] }
  } catch (error) {
    console.error("Error fetching admins:", error);
    throw error;
  }
};

export const fetchUsers = async (projectFilter) => {
  try {
   // const response = await axiosInstance.get("/api/users/user-list");
   const url = projectFilter ? `/api/users/user-list?project=${projectFilter}` : "/api/users/user-list";
    
    const response = await axiosInstance.get(url);
    return response.data.data; // Assuming API returns { success: true, data: [...] }
  } catch (error) {
    console.error("Error fetching admins:", error);
    throw error;
  }
};
export const fetchPrizeList= async () => {
  try {
   // const response = await axiosInstance.get("/api/users/user-list");
   const url =   "/api/users/user-list";
    
    const response = await axiosInstance.get(url);
    return response.data.data; // Assuming API returns { success: true, data: [...] }
  } catch (error) {
    console.error("Error fetching admins:", error);
    throw error;
  }
};



export const changePassword = async (oldPassword, newPassword) => {
  try {
    const response = await axiosInstance.post("/api/users/change-password", {
      oldPassword,
      newPassword,
    });
    
    // Assuming API response contains success message
    return response.data; 
  } catch (error) {
    console.error("Error changing password:", error);

    // Handle different error types (e.g., network error, validation error)
    if (error.response) {
      throw new Error(error.response.data.message || "Failed to change password");
    } else {
      throw new Error("Network error. Please try again.");
    }
  }
};
